import { render, staticRenderFns } from "./MedicalRequirementsPlanDownload.vue?vue&type=template&id=04a688ee&scoped=true&"
import script from "./MedicalRequirementsPlanDownload.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a688ee",
  null
  
)

export default component.exports